import { useEffect, useState } from "react";
import likeTrue from "../../assets/image/likeTrue.svg";
import likeFalse from "../../assets/image/likeFalse.svg";
import disLikeTrue from "../../assets/image/disLikeTrue.svg";
import disLikeFalse from "../../assets/image/disLikeFalse.svg";
import "./BotRating.scss";

interface IBotRatingProps {
  message?: any,
  modifyMessage?: any,
  handleTaskList?: any
}

export function BotRating(props: IBotRatingProps) {
  const { message, modifyMessage, handleTaskList } = props;
  const [isCheckLike, setCheckLike] = useState(false);
  const [isCheckDisLike, setCheckDislike] = useState(false);
  const thumbsUp = () => {
    message.cloudCustomData = "thumbsUp";  // 对消息点踩
    modifyMessage(message)
    setCheckLike(!isCheckLike);
    setCheckDislike(false);
    handleTaskList('reply')
  };

  const thumbsDown = () => {
    message.cloudCustomData = "thumbsDown"; // 对消息点赞
    modifyMessage(message)
    setCheckLike(false);
    setCheckDislike(!isCheckDisLike);
    handleTaskList('reply')
  };

  return (
    <>
      <div className="bot-rating">
        <img
          src={message.cloudCustomData === 'thumbsUp' || isCheckLike ? likeTrue : likeFalse}
          alt=""
          onClick={thumbsUp}
        />
        <img
          src={message.cloudCustomData === 'thumbsDown' || isCheckDisLike ? disLikeTrue : disLikeFalse}
          alt=""
          onClick={thumbsDown}
        />
      </div>
    </>
  );
}
